import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "./authentication.service";
import { InstancesService } from "./viewer/instances.service";
import { of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private instanceService: InstancesService,
  ) {}

  register(user) {
    return this.http.post(`${environment.viewerUrl}/api/auth/signup`, user);
  }

  getUserNotifications(
    instanceId: number,
    notificationsType: string,
    startDate: Date,
    endDate: Date,
  ) {
    if (instanceId) {
      return this.http.get(
        `${environment.viewerUrl}/api/notifications/getNotifications?instanceId=${instanceId}&${this.authenticationService.getQueryAuth()}&type=${notificationsType}&startDate=${startDate.toLocaleDateString(
          "en-CA",
        )}&endDate=${endDate.toLocaleDateString("en-CA")}`,
      );
    } else {
      return of();
    }
  }
}
